import { Theme } from '@mui/material'

const useStyles = {
  addPhoto: (theme: Theme) => ({
    display: 'block',
    margin: `${theme.spacing(2)} auto ${theme.spacing(3)}`,
  }),
  detailedInfo: {
    fontStyle: 'italic',
    fontWeight: 700,
  },
  optionalText: (theme: Theme) => ({
    marginTop: theme.spacing(1.5),
    fontStyle: 'italic',
    fontWeight: 700,
    fontSize: '14px',
  }),
  centeredGrid: {
    textAlign: 'center' as const,
  },
  recommendedText: (theme: Theme) => ({
    color: theme.palette.primary.main,
    fontStyle: 'italic',
    fontSize: '12px',
    margin: theme.spacing(-1, 0, 3),
  }),
  thumbnail: (theme: Theme) => ({
    width: '98px',
    height: '98px',
    objectFit: 'cover' as const,
    borderRadius: '100px',
    display: 'block',
    margin: `${theme.spacing(2)} auto ${theme.spacing(0)}`,
  }),
  changePhotoBtn: (theme: Theme) => ({
    marginBottom: theme.spacing(2),
  }),
}

export default useStyles
